import { CommonJobsStatus, InsightsKey } from "../../../api/aiInsights";
import { RootState } from "../../../app/store";
import { aiInsightsAdapter, insightsConfigAdapter } from "./aiInsightsSlice";

export const isInsightsNotGenerated = (state: RootState) => {
    const insightsData = state.insightsData;
    return insightsData.status === 'succeeded' && insightsData.insights.ids.length === 0
}

export const selectAIInsightsStatus = (state: RootState) => {
    return state.insightsData.status
};

const {selectAll: selectAllInsights} = aiInsightsAdapter.getSelectors()

export const areAllInsightsInProgress = (state: RootState) => {
    const insightsData = state.insightsData;
    const insights = selectAllInsights(insightsData.insights);
    return insights.every((insight) => (insight.status===CommonJobsStatus.IN_PROGRESS || insight.status===CommonJobsStatus.SUBMITTED));
}

export const areAllInsightsFailed = (state: RootState) => {
    const insightsData = state.insightsData;
    const insights = selectAllInsights(insightsData.insights);
    return insights.every((insight) => insight.status===CommonJobsStatus.FAILED);
}

export const selectAllAIInsights = (state: RootState) => {
    return selectAllInsights(state.insightsData.insights);
}

const {selectById: selectConfigById } = insightsConfigAdapter.getSelectors();

export const selectInsightConfig = (insightKey: InsightsKey) => ((state: RootState) => {
    const insightConfigs = state.insightsData.configs;
    return selectConfigById(insightConfigs, insightKey);
})